import colors from "./colors"

const globalStyles = {
  "@global": {
    body: {
      margin: 0,
      boxSizing: "border-box",
    },
    "h1, h2, h3, h4, h5, h6, div": {
      fontFamily: "Jost",
    },
    h2: {
      fontSize: "calc(44px + 2vmin)",
    },
    p: {
      fontFamily: "Jost",
      fontSize: "calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)))",
    },
    div: {
      boxSizing: "inherit",
    },
  },
}

export const RESULTS_BREAKPOINT = 920 // px
export const MOBILE_BREAKPOINT = 650 // px
export const SMALL_MOBILE_BREAKPOINT = 480 // px

export const pagePadding = "4rem"
export const INPUT_FADEIN = "i-fadeIn"
export const INPUT_FADEOUT = "i-fadeOut"
export const RESULTS_FADEIN = "r-fadeIn"
export const RESULTS_FADEOUT = "r-fadeOut"
export const ANIMATION_DURATION = 0.5 // seconds

export const container = {
  position: "absolute",
  top: 0,
  left: 0,
  minHeight: "100%",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  padding: pagePadding,
  [`@media only screen and (max-width: ${MOBILE_BREAKPOINT}px)`]: {
    padding: 0,
  },
}

export const bounds = {
  width: "100%",
  maxWidth: "1100px",
  minHeight: "80vh",
  [`@media only screen and (max-width: ${SMALL_MOBILE_BREAKPOINT}px)`]: {
    padding: "3rem 2rem",
  },
}

export const inputStyle = {
  boxSizing: "border-box",
  height: "4rem",
  maxHeight: "60px",
  backgroundColor: "rgba(255, 255, 255, 0.78)",
  color: colors.black,
  border: 0,
  borderBottom: `2px solid ${colors.orangeHighlight}`,
  fontFamily: "Futura",
  fontSize: "calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)))",
  fontWeight: 500,
  outline: "none",
  padding: "1rem 1.3rem",
  "&::placeholder": {
    fontFamily: "Futura",
    fontSize: "calc(12px + (16 - 12) * ((100vw - 300px) / (1600 - 300)))",
    fontStyle: "italic",
    color: colors.inputPlaceholder,
  },
  "@media only screen and (max-width: 920px)": {
    marginTop: "0.5rem",
  },
  [`@media only screen and (max-width: ${SMALL_MOBILE_BREAKPOINT}px)`]: {
    maxHeight: "30px",
    paddingLeft: "14px",
    marginTop: "0.5rem",
  },
}

export default globalStyles
